export default __webpack_public_path__ + "static/media/salaries-icon.58d08a58.svg";